import { Button } from "@/components/flexkit/Button";
import { useFlagPrebuildsEnabled } from "@/hooks/use-flag";
import { useTriggerPrebuild } from "@/hooks/use-trigger-prebuild";
import { type FC } from "react";

type TriggerPrebuildButtonProps = {
    projectId: string;
    environmentClassIds: string[];
};

export const TriggerPrebuildButton: FC<TriggerPrebuildButtonProps> = ({ projectId, environmentClassIds }) => {
    const { value: isPrebuildsEnabled } = useFlagPrebuildsEnabled();
    const { trigger, isSubmitting } = useTriggerPrebuild(projectId, environmentClassIds);

    return (
        <Button
            variant="secondary"
            size="sm"
            onClick={trigger}
            loading={isSubmitting}
            disabled={!isPrebuildsEnabled}
            title={!isPrebuildsEnabled ? "Prebuilds are not enabled for this org" : undefined}
            data-testid="trigger-prebuild-button"
            data-tracking-id="trigger-prebuild-button"
        >
            Prebuild
        </Button>
    );
};
